import React from 'react';
import classnames from 'classnames';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import Image from 'swag-client-common/components/ui/image';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import { getArticle } from 'swag-client-common/utils/get-article-by-colors.util';
import Loading from 'swag-client-common/components/info/loading';
import { IMAGE_EXTENSIONS, MIME_TYPES } from 'swag-client-common/utils/constants';
import { PantoneColorPickerExtended } from '../../info/pantone-color-picker-extended';
import classes from './max-print-colors-limit-exceeded-popup.scss';
const paperClasses = {
  paper: classes.paperClass
};
const titleClasses = {
  root: classes.titleClass
};
const MaxPrintColorsLimitExceededPopup = ({
  view,
  preview,
  maxPrintColors,
  colors,
  variantColor,
  loading,
  isButtonDisabled,
  isLimitedEdition,
  addColorEnabled,
  removeColorEnabled,
  shouldShowCompanyArtFolder,
  cancelUploading,
  onUploadNewLogo,
  onColorRemove,
  onColorAdd,
  onContinueClick,
  onClose,
  onSelectLogoFromList
}) => {
  const isMobileView = isMobile();
  const isDesktopView = !isMobileView;
  const handleUploadFile = e => {
    var _e$target$files;
    const file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    onUploadNewLogo(file, view);
  };
  const handleNewLogoUpload = e => {
    if (shouldShowCompanyArtFolder) {
      e.preventDefault();
      onSelectLogoFromList(view);
    }
  };
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.column, classes.settingColumn)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingsContentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement("h2", null, "This product has a color limit")), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "This product allows only ", getArticle(maxPrintColors), "\xA0", /*#__PURE__*/React.createElement("u", null, /*#__PURE__*/React.createElement("b", null, maxPrintColors, "\xA0", maxPrintColors > 1 ? 'colors' : 'color')), "\xA0to print.\xA0", /*#__PURE__*/React.createElement("input", {
    id: "upload-another-logo",
    type: "file",
    accept: `${MIME_TYPES.join(',')}, ${IMAGE_EXTENSIONS.join(',')}`,
    className: classes.hidden,
    multiple: false,
    onChange: handleUploadFile
  }), /*#__PURE__*/React.createElement("span", null, "Please\xA0", /*#__PURE__*/React.createElement("label", {
    onClick: handleNewLogoUpload,
    htmlFor: "upload-another-logo",
    className: classnames(classes.link, {
      [classes.orangeLink]: isLimitedEdition
    })
  }, "upload a new design"), "\xA0or remove some colors.")), isMobileView && /*#__PURE__*/React.createElement("div", {
    style: {
      background: variantColor
    },
    className: classnames(classes.column, classes.previewColumn)
  }, loading ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(Image, {
    src: preview,
    className: classes.logo,
    wrapperClassName: classes.previewImageWrapper,
    alt: "preview"
  })), /*#__PURE__*/React.createElement(PantoneColorPickerExtended, {
    colors: colors,
    className: classes.pantoneColorPicker,
    addColorEnabled: addColorEnabled,
    removeColorEnabled: removeColorEnabled,
    isLimitedEdition: isLimitedEdition,
    onColorRemove: onColorRemove,
    onColorAdd: onColorAdd,
    hasColors: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "ConfirmColorsForOneProduct",
    disabled: isButtonDisabled,
    className: classnames(classes.buttonContinue, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    type: "primary",
    size: "normal",
    onClick: () => onContinueClick(),
    textTransform: ButtonTextTransform.none
  }, "Confirm"))), isDesktopView && /*#__PURE__*/React.createElement("div", {
    style: {
      background: variantColor
    },
    className: classnames(classes.column, classes.previewColumn)
  }, loading ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(Image, {
    src: preview,
    className: classes.logo,
    wrapperClassName: classes.previewImageWrapper,
    alt: "preview"
  })));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "ColorLimit",
    content: content,
    onClose: () => {
      onClose();
      cancelUploading();
    },
    open: true,
    popupClassName: classes.dialogClass,
    classes: paperClasses,
    titleClasses: titleClasses,
    contentClass: classes.wrapper,
    closeClass: classnames(classes.closeClass, {
      [classes.orangeClose]: isLimitedEdition
    })
  });
};
export default MaxPrintColorsLimitExceededPopup;